import { Button, Clickable, Col, Icon, Row, Spinner, Text } from 'components';
import { getDate, getMonth, getYear } from 'date-fns';
import { Api, formatLocale, theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ConnectRequest = ({ data }) => {
  const [loading, setLoading] = useState(),
    [pendingConnects, setPendingConnects] = useState(),
    { sender, type, timestamp, connect, amount, createdAt } = data,
    connects = useSelector((state) => state.connects),
    isMultiple = amount > 1 && true,
    { t } = useTranslation(),
    navigate = useNavigate(),
    dispatch = useDispatch();

  useEffect(() => {
    setPendingConnects(getConnects());
  }, [connects]);

  async function confirm() {
    setLoading(true);

    const connectIds = getConnects();
    const payload = { connectIds, notifId: data._id, status: 'rejected' };

    const res = await Api.post('/connects/confirm', payload);
    setLoading(false);
    if (!res) return;

    dispatch({
      type: 'ACCEPT_CONNECTS',
      payload
    });
  }

  async function refuse() {
    setLoading(true);

    const connectIds = getConnects();
    const payload = { connectIds, notifId: data._id, status: 'rejected' };

    const res = await Api.post('/connects/refuse', payload);
    setLoading(false);
    if (!res) return;

    dispatch({
      type: 'REFUSE_CONNECTS',
      payload
    });
  }

  /*
    Find connects sent at the notifications date
  */
  function getConnects() {
    const now = new Date(createdAt);
    const dateStart = new Date(getYear(now), getMonth(now), getDate(now));
    const dateEnd = new Date(getYear(now), getMonth(now), getDate(now) + 1);

    const foundConnects = connects.filter((x) => {
      if (x.status !== 'pending') return false;
      const createdAt = new Date(x.createdAt);

      return createdAt >= dateStart && createdAt <= dateEnd;
    });

    return foundConnects.map((x) => x._id);
  }

  return (
    <Clickable onClick={() => null}>
      <Col noFlex pad="21px 18px 16px 20px" marg="0 0 12px" bg={theme.GREY_10}>
        <Row wid="100%">
          <Icon dimensions={24} type="videoCamera" marg="3px 12px 0 0" col={theme.GREY_60} />

          <Row between wid="100%">
            {isMultiple ? (
              <Text med>{t('notifications.newRequests', { amount })}</Text>
            ) : (
              <Col noFlex wid="75%">
                <Text>
                  <Trans>
                    {t('notifications.connectRequest', { sender: sender.name || sender.username })}
                  </Trans>

                  <Text med>
                    ${connect?.cost / 100} {'\u2022'}
                  </Text>
                  {connect && formatLocale(new Date(connect.date), 'MMMM d, h:mm b')}
                </Text>
              </Col>
            )}

            <Text b2 med col={theme.GREY_60} marg="3px 0 0">
              {timestamp}
            </Text>
          </Row>
        </Row>

        {loading && (
          <Row centerAll marg="12px 0 0" ht="30px">
            <Spinner />
          </Row>
        )}

        {!loading && (!connect.status || connect.status === 'pending') && (
          <Row noFlex between wid="fit-content" marg="12px 0 0">
            <React.Fragment>
              <Button
                app
                pad="0 20px"
                small
                reverse
                bg="#000"
                icon="check"
                iconDimensions={13.2}
                text={isMultiple ? t('common.confirmAll') : t('common.confirm')}
                wid="49%"
                onClick={confirm}
              />

              <Button
                app
                pad="0 20px"
                small
                text={isMultiple ? t('common.refuseAll') : t('common.refuse')}
                bordered
                wid="49%"
                onClick={refuse}
              />
            </React.Fragment>
          </Row>
        )}
      </Col>
    </Clickable>
  );
};

export default ConnectRequest;
